import React from 'react'
import mathiasVerraesImg from '../../images/speakers/Mathias-Verraes.jpg'

const MathiasVerraesWorkshop = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
            <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="team-wrapper">
					<h3>Workshop: DDD Modelling vs Implementation by Mathias Verraes</h3>
                    <br />
                    <h4>Date: Thursday, 26 March</h4>
                    <h4>The Place: Wantsome, The Friendly IT Academy, Centris Building, Colonel Langa 17, Iași</h4>
                    <br />
                    <div className="row">
                        <div className="col-md-4">
                            <img src={mathiasVerraesImg} className="img-responsive" alt="Mathias Verraes" />
                            <ul className="social-icon">
                                <li><a href="https://www.linkedin.com/in/mathiasverraes/" target="_blank" className="fa fa-linkedin wow fadeIn" data-wow-delay="0.3s"></a></li>
                                <li><a href="https://twitter.com/mathiasverraes" target="_blank" className="fa fa-twitter wow fadeIn" data-wow-delay="0.6s"></a></li>
                                <li><a href="http://verraes.net" target="_blank" className="fa fa-bookmark wow fadeIn" data-wow-delay="0.6s"></a></li>
                            </ul>
                        </div>
                        <div className="col-md-7">
                        <p>
                        Mathias Verraes advises organisations on designing and modelling software for complex environments, including architecture, analysis, testing, and refactoring “unmaintainable” systems. He has worked with clients in Government, Logistics, Mobility, Energy, E-Commerce, and more. He teaches Domain-Driven Design courses and curates the DDD Europe conference. When he’s at home in Kortrijk, Belgium, he helps his two sons build crazy Lego contraptions.
                        </p>
                        </div>
                    </div>
                    <div className="row">
                        <h4>Schedule</h4>
                        <p>
                            <br />
                            08:30 - 09:00 - Registration<br />
                            09:00 - 13:00 -  Workshop<br />
                            13:00 - 14:00 - Lunch<br />
                            14:00 - 18:00 - Workshop<br />
                            <br />
                        </p>
                        <h4>About the workshop</h4>
                        <p>
                        The design patterns from Domain-Driven Design are gradually entering the collective consciousness of software developers. But most of the information out there focuses on mechanistic implementation details of the patterns: how to make an Entity in [insert favourite programming language], how to use the Repository pattern with [insert new hot ORM], how to make immutable Value Objects in [insert legacy framework]...
                        <br /><br />
                        Applied individually, these patterns are useful, but are not giving you the full potential of Domain-Driven Design.
                        <br /><br />
                        This one day training has a different approach. We address technical concerns in implementing the DDD patterns, but the focus is on the underlying principles and heuristics for building great domain-centric object-oriented code.
                        </p>
                        <ul className="list-group list-group-flush row">
                            <li className="list-group-item list-group-item-coloured col-xs-12">Why you’re underusing Value Objects</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Seeing objects as containers of lifecycles and consistency</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Discovering deeper domain concepts such as business rules, and lifting them into first class domain objects</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">The relevance of processes, behaviour, temporal modelling... for finding better Aggregate boundaries</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">How mutable software designs have distorted our perception of mutability in the domain</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Better heuristics for understanding a complex domain, and using them to drive a more focused design</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Reducing our dependance on service classes</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Designing an implementation model that not only encapsulates the domain, but communicates that design to future programmers and reduces their surface area for bugs</li>
                        </ul>
                        <br />
                        <p>
                        This workshop, aimed at programmers, is designed to give you immediate benefits when modelling and implementing the most important parts of your codebase.                        <br /><br />                        
                        </p>
                        <br />
                        <h4>Prerequisites</h4>
                        <p> 
                        The workshop is programming-language agnostic. You are expected to have some experience working in an object-oriented language, and have some notions of object-oriented design patterns and principles.
                        </p>
                    </div>                                        
                    <div className="content row" id="tickets">
                        <div className="plans">
                            <div className="plan">
                                <h2 className="plan-title">Workshop <br />Early bird</h2>
                                <ul className="plan-features">
                                    <li><strong>9 December - 19 January</strong></li>
                                </ul>
                                <p className="plan-price">€350</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets disabled" href="#" target="_blank"> Sold out </a>
                            </div>
                            <div className="plan plan-tall">
                                <h2 className="plan-title">Workshop <br />Normal</h2>
                                <ul className="plan-features">
                                    <li><strong>20 January - 8 March</strong></li>
                                </ul>
                                <p className="plan-price">€400</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets" href="https://forms.gle/QUouQAUX5LvEi9r89" target="_blank"> Register </a>
                            </div>
                            <div className="plan">
                                <h2 className="plan-title">Workshop <br />Late bird</h2>
                                <ul className="plan-features">
                                    <li><strong>8 March - 25 March</strong></li>
                                </ul>
                                <p className="plan-price">€450</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets disabled" href="#" target="_blank"> Not available </a>
                            </div>
                        </div>	
                    </div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default MathiasVerraesWorkshop


// WEBPACK FOOTER //
// ./src/pages/workshops/ddd-modelling-implementation.js